<div class="cont-check col-12">
      <label class="flex-center-v">
            <div class="real-cont-check-centrador flex-center-v">
                  <input type="checkbox" bind:checked={value} />
            </div>
            <div class="cont-texto pointer">
                  {texto}
            </div>
      </label>
</div>

<script>
      export let value = false; // Estado que guarda si el checkbox está marcado o no
      export let texto = "Acepto los términos y condiciones"; // Estado que guarda si el checkbox está marcado o no
</script>

<style>
      .cont-check {
            padding: 12px;
      }
      input[type="checkbox"]:checked {
            accent-color: #7f56da; /* Cambia el color del checkbox cuando está seleccionado */
      }
      input[type="checkbox"] {
            padding: 10px; /* Aumenta el padding del checkbox */
            transform: scale(1.5);
            margin-right: 12px;
      }
      .real-cont-check-centrador {
            width: 20px;
            height: 20px;
            padding-left: 3px;
            cursor: pointer;
      }
      .cont-texto {
            font-size: 14px;
            padding-left: 10px;
      }
</style>
